<template>
  <div class="PlannedRealisation">
    <FieldSet
      label="Geplande realisatiedatum"
      :values="values"
      :fields="fields"
      :layout="layout"
      :can-reset="correction"
      :disabled="disabled"
      :path="path"
      :planned-date-alert="plannedDateAlert"
    />
    <FieldSet
      label="Voorbereiding"
      class="pt-3"
      :values="values"
      :fields="fields"
      :layout="layoutTwo"
      :disabled="disabled"
      :path="path"
    />
  </div>
</template>

<script>
import FieldSet from '@/components/form/FieldSet'
import { preparationDateFields } from '@/config'

export default {
  name: 'PlannedRealisation',
  components: { FieldSet },
  props: {
    label: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: function() {
        return {}
      },
    },
    path: {
      type: String,
      default: 'PlannedRealisation',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    correction: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: {
        'PlannedDate': {
          'type': 'string',
          'title': '',
          'format': 'date',
        },
        'Permit': {
          'type': 'string',
          'title': 'Vergunning werkzaamheden aangevraagd',
          'enumNames': [
            'Ja',
            'NVT',
          ],
          'enum': [
            'yes',
            'nvt',
          ],
          'format': 'radio',
        },
       ...preparationDateFields
      },
      layout: [{
        'columns': '1fr',
        'fields': ['PlannedDate'],
      }],
      layoutTwo: [{
        'columns': '1fr 1fr',
        'fields': ['GridOperatorContract', 'ChargePointOrderDate'],
      }, {
        'columns': '1fr 1fr',
        'fields': ['Contractor', 'Permit'],
      }],
      plannedDateAlert: ''
    }
  },
  watch: {
    'values.PlannedRealisation.LastSavedPlannedDate': {
      immediate: true,
      handler (lastSavedDate) {
        this.plannedDateAlert = lastSavedDate ? this.formatDatePickerDate() : ''
      }
    }
  },
  methods: {
    formatDatePickerDate () {
      const plannedRealisation = this.values.PlannedRealisation
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      return `Geannuleerd op <b>${new Date(plannedRealisation.PlannedDateCancelledAt).toLocaleDateString('nl-NL', options)}</b>` +
        ` (de waarde was: <b>${new Date(plannedRealisation.LastSavedPlannedDate).toLocaleDateString('nl-NL', options)}</b>)`
    },
  }
}
</script>
